import React from 'react'

const DetailsProductionMaterial = () => {
    return (
        <div>DetailsProductionMaterial</div>
    )
}

export default DetailsProductionMaterial